export default function Privasi() {
  return (
    <div data-testid="page-privasi">
      <div className="pe-container pt-14 pb-16 max-w-3xl">
        <div className="pe-eyebrow">Privasi</div>
        <h1 className="mt-2 font-display font-bold text-3xl lg:text-4xl">Kebijakan privasi</h1>
        <div className="mt-6 text-[color:var(--pe-text)] space-y-4 leading-relaxed">
          <p>Dokumen ini menjelaskan pemrosesan data yang berlaku pada preview Proper Energy.</p>
          <h2 className="font-display font-semibold text-xl mt-6">Data yang dikumpulkan</h2>
          <ul className="list-disc pl-6 space-y-1 text-[color:var(--pe-text-muted)]">
            <li>Data simulasi (daya PLN, konsumsi, pola pemakaian, kondisi atap) yang Bapak/Ibu input.</li>
            <li>Data kontak pada formulir konsultasi (nama, nomor WhatsApp, kota, catatan).</li>
            <li>Snapshot hasil simulasi yang terhubung dengan lead ketika Bapak/Ibu kirim.</li>
          </ul>
          <h2 className="font-display font-semibold text-xl mt-6">Cara pemakaian</h2>
          <p className="text-[color:var(--pe-text-muted)]">
            Data dipakai untuk menghubungi Bapak/Ibu terkait permintaan konsultasi dan menyiapkan diskusi penawaran. Simulasi anonim tanpa kontak tidak disimpan.
          </p>
          <h2 className="font-display font-semibold text-xl mt-6">Penyimpanan & akses</h2>
          <p className="text-[color:var(--pe-text-muted)]">
            Data lead disimpan pada database Proper Energy dan hanya dapat diakses oleh tim internal yang berwenang. Preview ini belum menjalankan pengiriman otomatis pesan atau email di luar permintaan Bapak/Ibu.
          </p>
          <h2 className="font-display font-semibold text-xl mt-6">Kontak</h2>
          <p className="text-[color:var(--pe-text-muted)]">Pertanyaan tentang data dapat diajukan ke office@properenergy.id.</p>
        </div>
      </div>
    </div>
  );
}
